import { AHButton, Box, useLayoutContext } from "arkh";
import React from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { StyleSheet } from "react-native";

import { WidgetScreenPreviewProps } from "./WidgetScreenPreviewProps";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { WAPreviewContainer } from "../../WidgetAdd/WAPreviewContainer";

const PREVIEW_ITEM_COMPACT_HEIGHT = 170;

const styles = StyleSheet.create({
  item: {
    height: PREVIEW_ITEM_COMPACT_HEIGHT,
    width: PREVIEW_ITEM_COMPACT_HEIGHT,
    justifyContent: "center",
    alignItems: "center",
  },
});

export function WidgetScreenPreviewCompact(props: WidgetScreenPreviewProps) {
  const insets = useSafeAreaInsets();
  const layout = useLayoutContext();
  const intl_token = useIntlTokens();
  const children = props.children;

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
      insets={{
        bottom: insets.bottom,
      }}
      spaceLeft="medium"
      color="surface"
    >
      <Box
        style={{
          width: PREVIEW_ITEM_COMPACT_HEIGHT,
          height: PREVIEW_ITEM_COMPACT_HEIGHT,
        }}
      >
        <Box style={styles.item}>
          <WAPreviewContainer
            h={props.size.h}
            w={props.size.w}
            unitSize={70}
            scale={props.size.h === 3 ? 3 / 4 : props.size.h === 4 ? 2 / 4 : 1}
          >
            {children}
          </WAPreviewContainer>
        </Box>
      </Box>
      <AHButton
        themeType="primary"
        onPress={props.onSave}
        disabled={props.disabled}
        style={{
          flex: 1,
          marginHorizontal: layout.space.medium,
        }}
        labelStyle={{
          textAlign: "center",
        }}
        title={intl_token.Save}
        loading={props.loading}
      />
    </Box>
  );
}
